import { createSelectorCreator, defaultMemoize } from 'reselect';
const getExtendedGameStatus = (state) => state?.gameStateBadge?.extendedStatus || {};
const getGameStatus = (state) => state?.gameStateBadge?.gameStatus || {};

// Custom selector factory that won't invalidate unless statusCode has changed
export const createGameStatusSelector = createSelectorCreator(defaultMemoize, ({ statusCode }, { statusCode: previousStatusCode } = {}) => {
    return typeof statusCode !== 'undefined' && statusCode === previousStatusCode;
});

export const getGameStateBadgeState = createGameStatusSelector(
    [getGameStatus, getExtendedGameStatus],
    (gameStatus, extendedStatus) => {
        const { abstractGameState, statusCode } = gameStatus;
        return {
            abstractGameState,
            statusCode,
            ...extendedStatus
        };
    }
);
